const destinationactiondata = [
  {
    id: "extension",
    icon: "phone",
    title: "Extension",
  },
  {
    id: "ringgroup",
    icon: "account-group",
    title: "Ring Group",
  },
  {
    id: "voicemail",
    icon: "voicemail",
    title: "Voicemail",
  },
  {
    id: "recording",
    icon: "record-rec",
    title: "Recording",
  },
  {
    id: "other",
    icon: "dots-horizontal",
    title: "Other",
  },
];

export default destinationactiondata;
